import axios from "../axios-instance";

const TEMPLATE_TYPE_LABELS = {
  A: "Appointment request",
  C: "Confirmed / approved",
  R: "Rejected",
  CC: "Cancelled by client",
  RS: "Rescheduled",
  RM: "Reminder",
  CO: "Completed",
};

const USER_TYPE_LABELS = {
  A: "Admin",
  C: "Client",
  S: "Staff",
};

export { TEMPLATE_TYPE_LABELS, USER_TYPE_LABELS };

export const fetchSuperAdminEmailTemplates = () =>
  axios.get("super-admin/notification-templates/email");

export const saveSuperAdminEmailTemplate = (payload) =>
  axios.post("super-admin/notification-templates/email/save", payload);

export const fetchSuperAdminSmsTemplates = () =>
  axios.get("super-admin/notification-templates/sms");

export const saveSuperAdminSmsTemplate = (payload) =>
  axios.post("super-admin/notification-templates/sms/save", payload);
